import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// API
import * as API  from '../../utils/api';

// Components
import Header from '../../components/Global/Header';
import FormContainer from '../../components/Global/FormContainer';

class ManageMaintainerRequest extends Component {

  componentDidMount() {
    const { selectedResponse, token } = this.props.match.params;
    API.respondToMaintainerRequest(token, selectedResponse)
  }

  renderHeaderText(selectedResponse) {
    return selectedResponse === 'approve'
    ? (
      <h2>You Added a Maintainer to Your Profile</h2>
    )
    : (
      <h2>You Denied Access to Your Profile</h2>
    )
  }

  renderMessage(selectedResponse) {
    return selectedResponse === 'approve'
    ? (
      <div className="manage-maintainer-request-message">
        <p>
          You successfully added a maintainer to your profile.
        </p>
      </div>
    )
    : (
      <div className="manage-maintainer-request-message">
        <p>
          You denied maintainer access to your profile.
        </p>
        <p>
          If this was a mistake, you can add profile maintainers via your account settings.
        </p>
      </div>
    )
  }

  render() {
    const { path, user } = this.props;
    const { selectedResponse } = this.props.match.params;

    return (
      <div className="onboarding">
        <Header path={ path }/>
        <FormContainer optionalClassName="onboarding-manage-maintainer-request">
          <header>
            {this.renderHeaderText(selectedResponse)}
          </header>
          {this.renderMessage(selectedResponse)}
          <Link to={`${user.isLoggedIn ? '/settings/account-admins' : '/log-in'}`} className="cta invert full-width">
            {
              user.isLoggedIn
              ? 'Go to Account Settings'
              : 'Log In to Manage Your Account'
            }
          </Link>
        </FormContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(ManageMaintainerRequest)


// WEBPACK FOOTER //
// ./src/screens/Onboarding/ManageMaintainerRequest.js